export const ADVERTISER_ROUTE = "/:categoryName/forms/:advertiserName/:step?";

export const TOTAL_NUM_STEPS = 2;

export const INFO_STEP = "info";
export const CONTACT_STEP = "contact";
export const CONTINUE_STEP = "continue";
export const SUCCESS_STEP = "success";

export const CACHE_SIZE = 500;
